import React, { ReactNode } from 'react';
import { AnimatePresence } from 'motion/react';
import * as motion from 'motion/react-m';
import { AnimationProps } from '../hooks/useStack';
import MotionDiv from '@osmosis/nextjs-components/MotionDiv';

type Props = {
  current: ReactNode;
  animation: AnimationProps | undefined;
};

/**
 * StackTransition.
 */
const StackTransition = ({ current, animation }: Props): JSX.Element => {
  const Screen = () => {
    return (
      <AnimatePresence>
        <MotionDiv {...(animation as typeof motion.div)}>{current}</MotionDiv>
      </AnimatePresence>
    );
  };

  return <Screen />;
};

export default StackTransition;
